import React from 'react'
import './styles.scss'

interface Props {
  name: string
  info: string
  text: string | JSX.Element
}

export const Question = ({ name, info, text }: Props) => (
  <div className='Question'>
    <div className='person'>
      <div className='name'>{name}</div>
      <div className='info'>{info}</div>
    </div>
    <div className='segment'>
      <div className='text'>{text}</div> 
      {/* <div className='arrow-up' /> */}
    </div>
  </div>
)
